<template>
  <g>
    <defs>
      <path
        id="geofences-out-a"
        d="M11,0.82725 C17.0651724,0.82725 22,5.76112931 22,11.8263017 C22,17.8924224 17.0651724,22.8263017 11,22.8263017 C4.93482759,22.8263017 0,17.8924224 0,11.8263017 C0,5.76112931 4.93482759,0.82725 11,0.82725 Z M11,2.91250862 C6.08413793,2.91250862 2.0862069,6.91138793 2.0862069,11.8263017 C2.0862069,16.7421638 6.08413793,20.7410431 11,20.7410431 C15.9158621,20.7410431 19.9137931,16.7421638 19.9137931,11.8263017 C19.9137931,6.91138793 15.9158621,2.91250862 11,2.91250862 Z M11.0157414,10.6765172 C11.6482414,10.6765172 12.1631552,11.191431 12.1631552,11.8229828 C12.1631552,12.456431 11.6482414,12.9713448 11.0157414,12.9713448 C10.3832414,12.9713448 9.86832759,12.456431 9.86832759,11.8229828 C9.86832759,11.191431 10.3832414,10.6765172 11.0157414,10.6765172 Z M20.8592414,-1.57118762e-12 C21.9609257,-1.57118762e-12 22.8592414,0.897067998 22.8592414,1.99875234 C22.8592414,3.09918902 21.9609257,3.99750468 20.8592414,3.99750468 C19.7588047,3.99750468 18.8592414,3.09918902 18.8592414,1.99875234 C18.8592414,0.897067998 19.7588047,-1.57118762e-12 20.8592414,-1.57118762e-12 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use
        :fill="currentColor"
        :opacity="opacity"
        transform="translate(1 .173)"
        xlink:href="#geofences-out-a"
      />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>